import Vue from "vue";
import AppConfig from "@DataWebSite/Scripts/Config/AppConfig";
import { router } from "@DataWebSite/Scripts/Config/RouteConfig";
import { store } from "@DataWebSite/Scripts/Config/StoreConfig";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";
import DataWebConfig from "@Scripts/Config/DataWebConfig";
import hljs from "highlight.js";

export default class BasePage {
    public static async init() {
        await Localizer.init({
            defaultCulture: (<any>window).App.culture,
            resourceContexts: ["App", "Contact", "DataWebSite"]
        });

        this.initRequestVerificationToken();

        let DataWeb = (<any>window).DataWeb;
        if (DataWeb) {
            Vue.use(DataWeb.default);
            Vue.use(DataWebConfig);

            await DataWeb.Localizer.init({ defaultCulture: (<any>window).App.userCulture, resourceContexts: ["DataWeb", "Account"] });
        }

        AppConfig.AddComponents();
        AppConfig.AddDirectives();

        let vm = new Vue({
            el: "#app",
            router,
            store,
            created: function () {
                if (DataWeb) {
                    DataWeb.default.registerRoutes(router);
                    DataWeb.default.registerStoreModules(store);
                }
            }
        });

        (<any>window).App.instances.vm = vm;

        this.setHeader();
        this.setSectionMenu();
        this.setAsideNavigation()
        this.setCtaFooter();  
        
        hljs.highlightAll();
    }

    private static initRequestVerificationToken() {
        var antiforgerytoken = (<any>document.getElementsByName("__RequestVerificationToken")[0]).value;
        if (antiforgerytoken) {
            Axios.defaults.headers.common["RequestVerificationToken"] = antiforgerytoken;
        }
    }

    private static setHeader() {
        let header = document.getElementById("Header"),
            buttonMobile = document.getElementById("ButtonMobile");

        document.addEventListener("click", function (e) {
            if (!document.getElementById("Header").contains(<any>e.target)) {
                header.classList.remove("show-exp");
            }
        });

        if (buttonMobile) {
            buttonMobile.addEventListener("click", function () {
                header.classList.toggle("show");
                document.body.classList.toggle("overflow");
            });
        }
    }

    private static setSectionMenu() {
        let buttonMobile = document.getElementById("MenuSection"),
            overlay = document.getElementById("Overlay"),
            body = document.getElementById("Body");

        if (buttonMobile) {
            buttonMobile.addEventListener("click", function () {
                body.classList.add("show-sidemenu");
            });
        }

        if (overlay) {
            overlay.addEventListener("click", function () {
                body.classList.remove("show-sidemenu");
            });
        }
    }

    private static setAsideNavigation() {
        let titles = document.querySelectorAll(".title-wrapper");
        let pagelinks = document.querySelectorAll("[data-name]");
        let groupName = document.querySelector(".links-wrapper[data-selected]")?.getAttribute("data-name");
        
        for (const title of titles) {
            title.addEventListener("click", function () {
                let dataName = title.getAttribute("data-name");
                
                for (const pagelink of pagelinks) {
                    if (pagelink.getAttribute("data-name") !== dataName) {
                        pagelink.classList.remove("show");
                    }
                }

                var titleLinks = document.querySelectorAll("[data-name="+dataName+"]");
                for (const item of titleLinks) {
                    item.classList.toggle("show");
                }
            }, false);
        }

        for (const pagelink of pagelinks) {
            let dataName = pagelink.getAttribute("data-name");
            if (groupName === dataName) {
                pagelink.classList.toggle('show');

                var titleLinks = document.querySelectorAll(".title-wrapper[data-name="+dataName+"]");
                for (const item of titleLinks) {
                    if (!item.classList.contains("show")) {
                        item.classList.add("show");
                    }
                }
            }
        }

        let currentPage = document.querySelector(".item[data-selected]");
        let box = document.querySelector(".nav");
        
        if (!currentPage || !box) return;
        
        const elementRect = currentPage.getBoundingClientRect();
        const boxRect = box.getBoundingClientRect();
        
        const isVisible = (element, container) => {
          const { top, bottom } = element.getBoundingClientRect();
          const { top: containerTop, bottom: containerBottom } = container.getBoundingClientRect();
        
          return top >= containerTop && bottom <= containerBottom;
        };
        
        if (!isVisible(currentPage, box)) {
          const offset = elementRect.top - boxRect.top - (boxRect.height / 2) + (elementRect.height / 2);
        
          box.scrollTo({
            top: box.scrollTop + offset,
            behavior: 'instant'
          });
        }   
    }

    private static setCtaFooter() {
        let wrapper
        const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms))

        async function writingAll(stringTarget, container) {
            wrapper = document.querySelector('[' + container + ']')
            const stringsContainer = document.getElementsByClassName(stringTarget)

            while (wrapper) {
                for (let i = 0; i < stringsContainer.length; i++) {
                    const string = stringsContainer[i].textContent
                    await write(string)
                    await sleep(1000)
                    await erase()
                    await sleep(300)
                };
            }
        };

        async function write(text) {
            let index = 0
            while (index < text.length) {
                const timeout = 50
                await sleep(timeout)
                index++
                wrapper.innerHTML = text.substring(0, index)
            }
        };


        async function erase() {
            while (wrapper.textContent.length) {
                const timeout = 50
                await sleep(timeout)
                wrapper.textContent = wrapper.textContent.substring(0, wrapper.textContent.length - 2)
            }
        };

        writingAll("message", "data-text");
    }
}